import Policy from "../../../../components/company/organization/policy-configuration"

const PolicyConfigurationPage = () => {
    return <Policy/>
}

export default PolicyConfigurationPage;